import React from 'react';
import { Button } from '@mui/base/Button';
import type { UserModel } from '../types';

type UserTableProps = {
  users: UserModel[];
  onEdit: (id?: string) => void;
  onDelete: (user: UserModel) => void;
  tableClassName?: string;
  maxWidth?: string;
};

const UserTable: React.FC<UserTableProps> = ({
  users,
  onEdit,
  onDelete,
  tableClassName = 'table',
  maxWidth = '1000px',
}) => {
  return (
    <div style={{ width: '100%', maxWidth }}>
      <table className={tableClassName} style={{ width: '100%' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Name</th>
            <th style={{ textAlign: 'left' }}>Role</th>
            <th style={{ textAlign: 'left' }}>Email</th>
            <th style={{ textAlign: 'left' }}>Enabled</th>
            <th style={{ textAlign: 'left' }}>Lead</th>
            <th style={{ width: '110px' }}></th>
            <th style={{ width: '110px' }}></th>
            <th style={{ width: '110px' }}></th>
          </tr>
        </thead>

        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.role}</td>
              <td>{user.email}</td>
              <td>{user.isEnabled ? 'Yes' : 'No'}</td>
              <td>{user.isLead ? 'Yes' : 'No'}</td>
              <td></td>
              <td style={{ textAlign: 'right' }}>
                <Button
                  className="styled-button"
                  onClick={() => onEdit(user.id)}
                >
                  Edit
                </Button>
              </td>
              <td style={{ textAlign: 'right' }}>
                <Button
                  className="styled-button"
                  onClick={() => onDelete(user)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
